(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ComparativoNdviCtrl', ComparativoNdviCtrl);

  ComparativoNdviCtrl.$inject = [
    'mapas',
    'googleChartApiPromise',
    'LoadingService',
    'MessagesService',
    '$timeout'
  ];

  function ComparativoNdviCtrl(mapas, googleChartApiPromise, LoadingService, MessagesService, $timeout) {
    const vm = this;
    vm.mapas = mapas;

    function error(error) {
      LoadingService.hideLoading();
      console.error(error);
      MessagesService.alert('Fala ao iniciar dados.');
    }

    function init() {
      LoadingService.showLoading();

      googleChartApiPromise
        .then(() => {
          prepareChart();
          // Atraso para dar tempo de renderizar o gráfico
          $timeout(LoadingService.hideLoading, 1000);
        })
        .catch(error);
    }

    function getTicks() {
      const ticks = [];
      for(let i = 0; i <= 1; i+=0.1) {
        ticks.push(i);
      }
      return ticks;
    }

    function getRows() {
      return vm.mapas.map((mapa) => {
        const minValues = mapa.mapData.dados.legenda.map(item => +item.min);
        return {
          c: [
            {v: mapa.gleba.descricao},
            {v: minValues[minValues.length - 1] - minValues[0]},
            {v: minValues[0]},
            {v: minValues[minValues.length - 1]},
          ]
        };
      });      
    }
    
    function prepareChart() {
      vm.chart = {};

      vm.chart.type = 'LineChart';
          
      vm.chart.data = {
        'cols': [
          {id: 'x', label: 'mapa', type: 'string'},
          {id: 'variation', label: 'Variação', type: 'number'},
          {id: 'min', label: 'Mínimo', type: 'number'},
          {id: 'max', label: 'Máximo', type: 'number'},
        ],
        rows: getRows()
      };

      vm.chart.options =  {
        hAxis: {
          title: 'Mapa'
        },
        vAxis: {
          title: 'Valor',
          ticks: getTicks()
        }
      };
    }


    init();
  }
}());
